// Config de ambiente centralizada — equivalente ao `ngAuthSettings` (gulp-ng-config) do legado.
// A base da API NUNCA é cravada no código: vem de import.meta.env.VITE_*, escolhido pelo
// mode do Vite (development | homologation | production). Vars do shell (CI/host) sobrescrevem.

export type DataSourceMode = 'mock' | 'real'

export interface AppEnv {
  mode: string
  dataSource: DataSourceMode
  apiBase: string     // API v1 (monolito)
  apiBaseV2: string   // API v2 (ticketing)
  clientId: string
  googleClientId: string
  pusherKey: string
  pusherCluster: string
  firebaseUrl: string
  providerId: string
  locationId: string
  authToken: string | null
  meetBaseUrl: string
  trackerUrl: string
  forgotPasswordUrl: string
  singleDay: boolean
}

const E = import.meta.env
const strip = (s: string) => s.replace(/\/+$/, '')
const DEV_BASE = 'https://api.dev.filazero.net'

const DEFAULT_FORGOT_PASSWORD_URL_BY_MODE: Record<string, string> = {
  development: 'https://agende.dev.filazero.app/user/forgot-password',
  homologation: 'https://agende.stg.filazero.app/user/forgot-password',
  production: 'https://agende.filazero.app/user/forgot-password',
}

const DEFAULT_PUSHER_KEY_BY_MODE: Record<string, string> = {
  development: 'c183088020ce585dc463',
  homologation: '74ad49bc09ac0b9e0082',
  production: '07cf26e9e23d9756df1d',
}

function browserApiBase(value: string | undefined, fallback: string): string {
  const base = strip(value ?? fallback)
  if (!/^https?:\/\//i.test(base)) {return base}
  return ''
}

function browserApiBaseV2(value: string | undefined, fallback: string): string {
  const base = strip(value ?? fallback)
  if (!/^https?:\/\//i.test(base)) {return base}
  return '/v2'
}

export const env: AppEnv = {
  mode: E.MODE,
  dataSource: E.VITE_DATA_SOURCE === 'real' ? 'real' : 'mock',
  apiBase: browserApiBase(E.VITE_API_BASE, DEV_BASE),
  apiBaseV2: browserApiBaseV2(E.VITE_API_BASE_V2, DEV_BASE + '/v2'),
  clientId: E.VITE_CLIENT_ID ?? 'filazeroApp-dev',
  googleClientId: E.VITE_GOOGLE_CLIENT_ID ?? '',
  pusherKey: E.VITE_PUSHER_KEY || DEFAULT_PUSHER_KEY_BY_MODE[E.MODE] || '',
  pusherCluster: E.VITE_PUSHER_CLUSTER || 'sa1',
  firebaseUrl: E.VITE_FIREBASE_URL ?? '',
  providerId: E.VITE_PROVIDER_ID ?? '',
  locationId: E.VITE_LOCATION_ID ?? '',
  authToken: E.VITE_AUTH_TOKEN ?? null,
  meetBaseUrl: E.VITE_MEET_BASE_URL ?? 'https://meet.filazero.com.br/',
  trackerUrl: E.VITE_TRACKER_URL ?? 'https://entre.dev.filazero.app/track/',
  forgotPasswordUrl: E.VITE_FORGOT_PASSWORD_URL ?? DEFAULT_FORGOT_PASSWORD_URL_BY_MODE[E.MODE] ?? DEFAULT_FORGOT_PASSWORD_URL_BY_MODE.development,
  // ponytail: flag temporária p/ restringir a jornada a hoje — remover junto do código multi-dia quando virar permanente
  singleDay: E.VITE_SINGLE_DAY !== 'false',
}

// Banner no boot — deixa explícito qual ambiente/base está ativo.
export function logEnv(): void {
  console.info(`[filazero] mode=${env.mode} · dataSource=${env.dataSource} · apiBase=${env.apiBase} · v2=${env.apiBaseV2}`)
  if (!E.VITE_API_BASE) {console.warn('[filazero] VITE_API_BASE não definido — usando fallback de DEV.')}
}
